interface Props {
  title: string;
  value: number;
  strokeColor: string;
  fillColor: string;
  className?: string;
}

export default function CompleteRate({ title, value, strokeColor, fillColor, className }: Props) {
  const radius = 50;
  const strokeWidth = 7;
  const normalizedValue = Math.min(Math.max(value, 0), 100);
  const circumference = 2 * Math.PI * radius;
  const progress = (circumference * normalizedValue) / 100;
  // const offset = circumference - progress;  // bunda 95 olunca full dolu oluyor
  const offset = circumference - progress + (strokeWidth * progress) / 100;

  return (
    <div className={`flex flex-col items-center ${className}`}>
      <div className='flex items-center mb-2 h-12'>
        <div className='w-3 h-3 rounded-full mr-1.5' style={{ backgroundColor: strokeColor }} />
        <p className='text-gray-900 text-sm leading-5 font-medium dark:text-white'>{title}</p>
      </div>

      <svg viewBox='0 0 100 100' className='circular-progress px-16 md:px-3 min-h-[80px]'>
        <circle cx='50' cy='50' r={radius} fill={fillColor} />

        <circle
          cx='50'
          cy='50'
          r={radius - strokeWidth / 2}
          stroke={strokeColor}
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap='round'
          transform={'rotate(-90 50 50)'}
          fill='none'
        />
        <text
          x='50'
          y='50'
          textAnchor='middle'
          dominantBaseline='central'
          className='text-sm leading-7 font-medium'
        >
          {`${normalizedValue.toFixed(2)}%`}
        </text>
      </svg>
    </div>
  );
}
